import { GenerateLinkParams, PresignedUrlPayload } from '@zonofi/common';
import {
  DocumentRequest,
  RedingtonMediaRequest,
} from '@zonofi/seller-rtk-store';

export const isDocumentRequest = (
  params: GenerateLinkParams
): params is Omit<DocumentRequest, 'workspaceId'> => {
  return !!params && 'documentType' in params;
};

export const isS3Media = (
  params: GenerateLinkParams
): params is Omit<PresignedUrlPayload, 'method'> => {
  return (
    !!params && 'messageId' in params && 'cntType' in params && 'name' in params
  );
};

export const isRedingtonMedia = (
  params: GenerateLinkParams
): params is Omit<RedingtonMediaRequest, 'workspaceId'> => {
  return !!params && 'waConfigId' in params;
};
